<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Users</nz-page-header-title>
    <nz-page-header-extra class="mr4">
      <button
        nz-button
        nzTooltipTitle="Export Excel"
        nz-tooltip
        nzTooltipPlacement="top"
        (click)="exportFile('excel')"
      >
        <i nz-icon nzType="file-excel" nzTheme="outline"></i> Export Excel
      </button>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<div nz-row nzJustify="end" class="mt4">
  <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24" class="mb5 mr3">
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzFor="Date"
        >Search By User Type</nz-form-label
      >
      <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
        <!-- <nz-switch [(ngModel)]="switchValue"  (ngModelChange)="getAllTestSeries()"></nz-switch> -->
        <nz-select
          nzAllowClear
          nzShowSearch
          nzServerSearch
          id="selectedUserStatus"
          [(ngModel)]="selectedUserStatus"
          nzPlaceHolder="Select a type"
          (ngModelChange)="getAllUsers()"
        >
          <nz-option
            *ngFor="let item of allUserStatus"
            nzValue="{{ item.value }}"
            nzLabel="{{ item.label }}"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5 mr3">
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzFor="Date">Date</nz-form-label>
      <nz-form-control [nzSpan]="24" nzErrorTip="Please select a Date!">
        <nz-range-picker
          class="width-100"
          [(ngModel)]="dateRange"
          (ngModelChange)="onChangeDateRange($event)"
        ></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label [nzSpan]="24" nzFor="Date">Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by Users name"
        ngModel
        (ngModelChange)="searchUsers($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>
</div>

<nz-table
  #subjectTbl
  [nzData]="allUsers"
  [nzLoading]="loading"
  [nzTotal]="totalDataCount"
  [(nzPageSize)]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzFrontPagination]="false"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzShowSizeChanger
  [nzScroll]="{ x: '900px' }"
  *ngIf="listView"
>
  <thead>
    <tr>
      <th nzColumnKey="name" [nzSortFn]="true">User Name</th>
      <th>Email</th>
      <th>Mobile</th>
      <th>Created On</th>
      <th>Subscribe</th>
      <th nzWidth="100px">Status</th>
      <th class="text-right" nzWidth="200px">Action</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data of subjectTbl.data; index as i">
      <td>{{ data.name }}</td>
      <td>{{ data.email }}</td>
      <td>{{ data.mobile }}</td>
      <td>{{ data.createdAt | date : "mediumDate" }}</td>

      <td>
        <nz-tag *ngIf="data.subscriptionStatus" nzColor="green">
          {{ data.subscriptionStatus ? "Subscribed" : "" }}
        </nz-tag>
        <i
          *ngIf="data.subscriptionStatus"
          nz-icon
          nzType="info-circle"
          nzTheme="outline"
          class="cursor-pointer"
          (click)="openSubscriptionModal(data)"
        ></i>
      </td>

      <td>
        <span class="{{ data.status ? 'active' : 'inactive' }} status"></span>
      </td>

      <td class="action-buttons">
        <a
          nz-button
          nzTooltipTitle="Details"
          nzTooltipPlacement="topCenter"
          nz-tooltip
          [routerLink]="['/main/user/detail', data._id]"
          [queryParams]="
            selectedUserStatus === 'subscribedUser'
              ? { isSubscriber: true }
              : {}
          "
          routerLinkActive="router-link-active"
        >
          <i nz-icon nzType="eye" nzTheme="outline"></i>
        </a>

        <a
          class="action-button"
          nz-button
          nz-popconfirm
          [nzPopconfirmTitle]="
            'Are you sure ' +
            (data.status ? 'deActive' : 'active') +
            ' this User?'
          "
          (nzOnConfirm)="updateStatus(data._id, data.status)"
          [nzTooltipTitle]="data.status ? 'Deactive' : 'Active'"
          nzTooltipPlacement="topRight"
          nz-tooltip
        >
          <i
            [nzType]="data.status ? 'stop' : 'check'"
            nz-icon
            nzTheme="outline"
          ></i>
        </a>
      </td>
    </tr>
  </tbody>
</nz-table>
